import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  withStyles,
  Paper,
  Grid,
  List,
  Divider,
  Typography
} from '@material-ui/core'
import { Element } from 'react-scroll'
import { format } from 'date-fns'

import {
  getSelectedDayAvailabilities,
  isAvailabilitiesLoading
} from '../../store/availability/selectors'
import { HourPickerItem } from './HourPickerItem'
import { bookingSelectHour } from '../../store/booking/actions'
import { getSelectedHour, getSelectedDay } from '../../store/booking/selectors'
import { Loading } from '../atoms/Loading'
import {
  getGarageDateFirstDay,
  getGarageDateLastDay
} from '../../store/garage/selectors'

const styles = theme => ({
  root: { padding: theme.spacing.unit },
  title: {
    margin: theme.spacing.unit,
    marginBottm: 0
  },
  centered: {
    textAlign: 'center'
  }
})

export class HourPickerBase extends Component {
  isHourSelected = orario => {
    const { selectedHour } = this.props
    return selectedHour && selectedHour.id === orario.id
  }

  renderNoDay = () => {
    const { classes } = this.props
    return (
      <div>
        <Typography
          variant="h6"
          className={[classes.title, classes.centered].join(' ')}
        >
          Nessun giorno selezionato
        </Typography>
      </div>
    )
  }

  renderBeforeLimit = startDay => {
    const { classes } = this.props
    return (
      <div>
        <Typography
          variant="h6"
          className={[classes.title, classes.centered].join(' ')}
        >
          Non si possono effettuare prenotazioni precedenti al{' '}
          {format(startDay, 'DD/MM/YYYY')}
        </Typography>
      </div>
    )
  }

  renderAfterLimit = endDay => {
    const { classes } = this.props
    return (
      <div>
        <Typography
          variant="h6"
          className={[classes.title, classes.centered].join(' ')}
        >
          Non si possono effettuare prenotazioni successive al{' '}
          {format(endDay, 'DD/MM/YYYY')}
        </Typography>
      </div>
    )
  }

  renderHoliday = () => {
    const { classes } = this.props
    return (
      <div>
        <Typography
          variant="h6"
          className={[classes.title, classes.centered].join(' ')}
        >
          Giorno festivo
        </Typography>
      </div>
    )
  }

  renderHalfDay = (day, tipo, title) => {
    const { classes, onChange } = this.props
    return (
      <Grid item xs={6}>
        <Typography variant="h6" className={classes.title}>
          {title}
        </Typography>
        <List>
          {day.orari
            .filter(orario => orario.tipo === tipo)
            .map((orario, index) => (
              <React.Fragment key={orario.id}>
                {index > 0 && <Divider />}
                <HourPickerItem
                  hour={orario}
                  selected={this.isHourSelected(orario)}
                  onClick={() => onChange(orario)}
                />
              </React.Fragment>
            ))}
        </List>
      </Grid>
    )
  }

  renderSelectedDay = day => {
    return (
      <Grid container spacing={16}>
        {this.renderHalfDay(day, 'MATTINA', 'Mattina')}
        {this.renderHalfDay(day, 'POMERIGGIO', 'Pomeriggio')}
      </Grid>
    )
  }

  selectComponentForDay = day => {
    const { dateLimitStart, dateLimitEnd, selectedDay } = this.props
    if (day === null) return this.renderNoDay()

    if (selectedDay < dateLimitStart)
      return this.renderBeforeLimit(dateLimitStart)
    if (selectedDay > dateLimitEnd) return this.renderAfterLimit(dateLimitEnd)
    if (day.tipo === 'FESTIVO') return this.renderHoliday()
    return this.renderSelectedDay(day)
  }

  render() {
    const { classes, dayAvailabilities, isLoading } = this.props

    return (
      <Element name="hourPicker">
        {isLoading ? (
          <Paper className={[classes.root, classes.centered].join(' ')}>
            <Loading />
          </Paper>
        ) : (
          <Paper ref={this.containerRef} className={classes.root}>
            {this.selectComponentForDay(dayAvailabilities)}
          </Paper>
        )}
      </Element>
    )
  }
}

export const HourPicker = withStyles(styles)(HourPickerBase)

const mapStateToProps = state => ({
  dayAvailabilities: getSelectedDayAvailabilities(state),
  selectedDay: getSelectedDay(state),
  selectedHour: getSelectedHour(state),
  dateLimitStart: getGarageDateFirstDay(state),
  dateLimitEnd: getGarageDateLastDay(state),
  isLoading: isAvailabilitiesLoading(state)
})

const mapDispatchToProps = dispatch => ({
  onChange: hour => dispatch(bookingSelectHour(hour))
})

export const LinkedHourPicker = connect(
  mapStateToProps,
  mapDispatchToProps
)(HourPicker)
